(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-score.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-score.js');
"use strict";


const {
  EventRowHeader,
  EventRowOutcomes
} = svs.components.sport.quickplayModal.coupons.CouponScoreParts;
const CouponScore = _ref => {
  let {
    branding,
    drawData,
    isPixMix
  } = _ref;
  const {
    productId,
    events
  } = drawData || {};
  return React.createElement("div", {
    className: "u-flex u-flex-column u-flex-justify-content-between notranslate"
  }, events.map((eventItem, eventIndex) => React.createElement("section", {
    className: "coupon-score-event",
    key: "qp-score-event-".concat(eventItem.captionShort)
  }, React.createElement(EventRowHeader, {
    bradning: branding,
    eventIndex: eventIndex,
    eventItem: eventItem
  }), React.createElement(EventRowOutcomes, {
    eventIndex: eventIndex,
    isPixMix: isPixMix,
    productId: productId
  }))));
};
setGlobal('svs.components.sport.quickplayModal.coupons.CouponScore', CouponScore);

 })(window);